import { initialState } from "./slice";
import { createSelector } from "reselect";

export const selectApp = (state) =>
  state.app || initialState;

export const selectApiError = createSelector(
  selectApp,
  (appState) => appState.apiError
);

export const selectRemainingCredits = createSelector(
  selectApp,
  (appState) => appState.remainingCredits
);

